import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { DateRange, Subcontractor } from '../../../../_shared/model';
import { HelperService, StorageService } from '../../../../_shared/services';
import { CommonService, ReportsService } from '../../../pages/home/_services';

@Component({
    selector: 'app-availability-report-popup',
    templateUrl: './availability-report-popup.component.html',
    styleUrls: ['./availability-report-popup.component.scss'],
})
export class AvailabilityReportPopupComponent implements OnInit {
    private onDestroy$ = new Subject<void>();
    public mainForm: FormGroup;
    public isSelectedAll = true;
    public daterange: DateRange = new DateRange().deserialize({ start: moment(), end: moment() });
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public options: any = this.helper.getDateRangeSettingsSubconstractorCalendar(this.daterange.start, this.daterange.end);

    private allSubcontractors: Subcontractor[];
    constructor(
        public activeModal: NgbActiveModal,
        private commonRest: CommonService,
        private storage: StorageService,
        private fb: FormBuilder,
        private helper: HelperService,
        private rest: ReportsService,
    ) {}

    ngOnInit() {
        this.commonRest
            .getAllSubcontractors(this.storage.getSelectedContractor().id)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(subcontractors => {
                this.allSubcontractors = subcontractors;
                this.createForm();
            });
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
    ngOnDestroy(): void {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.onDestroy$.next();
    }

    public createReport(): void {
        this.rest
            .getDailyAvailabilityReport(
                this.storage.getSelectedContractor().id,
                this.getSelectedSubcontractors(),
                this.daterange.start.format('YYYY-MM-DD'),
                this.daterange.end.format('YYYY-MM-DD'),
            )
            .pipe(
                map(res => {
                    if (res.type !== 0) {
                        return new Blob([res.body], { type: 'application/pdf' });
                    }
                }),
            )
            .subscribe(res => {
                if (res) {
                    this.helper.openDocumentViewer(
                        res,
                        res.type,
                        `izpis_iz_koledarja (${this.daterange.start.format('DD.MM.YYYY')}-${this.daterange.end.format('DD.MM.YYYY')}).pdf`,
                    );
                }
            });
    }

    private getSelectedSubcontractors(): number[] {
        const result: number[] = [];
        this.mainForm.controls.items.value.map(el => {
            if (el.selected) {
                result.push(_.get(el, 'data.id'));
            }
        });
        return result;
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public selectedDate(value: any, datepicker?: any) {
        // any object can be passed to the selected event and it will be passed back here
        datepicker.start = value.start;
        datepicker.end = value.end;
        // or manupulat your own internal property
        this.daterange.start = value.start;
        this.daterange.end = value.end;
        this.daterange.label = value.label;
        // this.getCommunicationList();
    }

    public isAllSelected(): void {
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.isSelectedAll = this.mainForm.controls.items.value.every((el: any) => el.selected);
    }

    public onChangeSelect(): void {
        this.isSelectedAll = !this.isSelectedAll;
        this.mainForm.controls.items['controls'].forEach(element => {
            element.controls.selected.setValue(this.isSelectedAll);
        });
    }

    public createForm(): void {
        this.mainForm = this.fb.group({
            items: this.fb.array(this.createItems()),
        });
    }

    private createItems(): FormGroup[] {
        if (_.isNil(this.allSubcontractors)) {
            return [];
        }
        return this.allSubcontractors.map((el: Subcontractor) => {
            return this.fb.group({
                selected: this.fb.control({ value: true, disabled: false }),
                // id: this.fb.control({ value: el.id, disabled: false }),
                data: this.fb.control({ value: el, disabled: false }),
            });
        });
    }
}
